import React, { useEffect } from 'react';

const MoneyRain = () => {
  useEffect(() => {
    // Initialize money rain effect
    const createMoneyRain = () => {
      const symbols = ['$', '₿', '€', '£', '¥', '₴', '₽', '₹', '₩', '₮', '₸'];
      let container; // Changed from const to let
      
      // Check if container already exists
      if (!document.getElementById('moneyRain')) {
        container = document.createElement('div');
        container.id = 'moneyRain';
        container.className = 'fixed inset-0 pointer-events-none z-0 opacity-10';
        container.style.overflow = 'hidden';
        document.body.appendChild(container);
      } else {
        container = document.getElementById('moneyRain');
        container.innerHTML = '';
      }
  
      // Create new symbols
      for (let i = 0; i < 50; i++) {
        const symbol = document.createElement('div');
        symbol.className = 'money-symbol';
        symbol.textContent = symbols[Math.floor(Math.random() * symbols.length)];
        symbol.style.left = `${Math.random() * 100}vw`;
        symbol.style.animationDuration = `${5 + Math.random() * 15}s`;
        symbol.style.animationDelay = `${Math.random() * 5}s`;
        symbol.style.opacity = `${0.1 + Math.random() * 0.3}`;
        symbol.style.fontSize = `${Math.floor(12 + Math.random() * 24)}px`;
        symbol.style.position = 'absolute';
        container.appendChild(symbol);
      }
    };

    // Initial creation
    createMoneyRain();

    // Refresh the effect periodically to ensure it's always active
    const refreshInterval = setInterval(createMoneyRain, 30000);

    // Cleanup
    return () => {
      clearInterval(refreshInterval);
      const container = document.getElementById('moneyRain');
      if (container) {
        container.remove();
      }
    };
  }, []);

  return null; // This component doesn't render anything directly
};

export default MoneyRain;